import { coreTranslations } from '@sentinel/web-core';
import console from './console.json';

/** Italian: the fallback language. Keys are `module.context.key`. */
const it = { ...coreTranslations.it, console };
export default it;
